import { COLORS } from "../../../utils/js/constants";

export default function providerPageStyle(theme) {
    return {
        card: {
            display: 'flex',
            background: COLORS.grey,
            alignItems: 'center',
            margin: '5px 0',
            border: 'solid #a0a0a0 1px',
            padding: 5,
            color: 'white'
        },
        root: {
            display: "flex",
        },
        appBarSpacer: theme.mixins.toolbar,
        content: {
          flexGrow: 1,
          height: "100vh",
          overflow: "auto",
          backgroundColor: COLORS.dark,
        },
        container: {
            paddingTop: theme.spacing(4),
            paddingBottom: theme.spacing(4),
        },
        containerProducts: {
            padding: theme.spacing(4),
            display: 'flex',
            overflow: 'auto',
            flexDirection: 'column',
            background: COLORS.grey,
        },
        title: {
            color: COLORS.lightYellow,
            display: 'flex',
            alignItems: 'center',
            paddingBottom: 10
        },
        information: {
            color: COLORS.white,
            display: 'flex',
            alignItems: 'center',
        },
        registerButton: {
            background: COLORS.green2,
            color: 'white',
            fontWeight: 'bold'
        },
        textWrap: {
            display: 'flex',
        },
        textPrimary: {
            color: COLORS.white
        },
        textSecondary: {
            color: COLORS.lightGrey,
            paddingLeft: "5px"
        }
    }
}
